import { useQuery } from 'react-query'
import { useUser } from '@/src/modules/auth/context/AuthProvider'
import CheckUserKYCApplicationStatus from '@/src/common/queries/CheckUserKYCApplicationStatus'

const useCheckUserKYCApplicationStatus = () => {
    const { user } = useUser()
    const userUid: string = user?.uid ?? ''

    const { data, error, isLoading, isSuccess, isError, refetch } = useQuery(
        'checkUserKYCApplicationStatus',
        () => CheckUserKYCApplicationStatus(userUid),
        {
            // @ts-ignore
            refetchOnWindowFocus: false,
            enabled: false,
        }
    )

    return { data, error, isLoading, isSuccess, isError, refetch }
}

export default useCheckUserKYCApplicationStatus
